import routes from "@/config/routes.ts";
import useOneToOne from "@/utils/hooks/useOneToOne.ts";
import Button from "@edusogno/primitives/button";
import cn from "classnames";
import { FC, PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PageHeading from "../ui/PageHeading";
import { ChevronLeft } from "lucide-react";

interface MobileLayoutProps {
  isLoading?: boolean;
  title?: string,
  subtitle?: string
  heading?: string;
  subheading?: string;
  className?: string;
  isOneToOne?: boolean
}

const MobileLayout: FC<PropsWithChildren<MobileLayoutProps>> = ({
  children,
  title,
  subtitle,
  heading,
  subheading,
  className,
  isOneToOne = true
}) => {
  const { credits: stateCredits } = useOneToOne();

  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div
      className={
        "flex-col relative flex h-screen overflow-y-scroll  pt-3  w-full md:mt-0"
      }
    >
      <button className="px-2" onClick={() => window.history.back()}>
        <ChevronLeft color="white" />
      </button>
      <PageHeading
        title={title || t("one_to_one.title")}
        subtitleClassName={"!text-light"}
        subtitle={subtitle || t("one_to_one.subtitle")}
        className={"until-lg:px-4 until-lg:pb-0"}
      />
      {!isOneToOne &&
        <div className="mt-2"></div>

      }
      {isOneToOne && <div className={"flex flex-row justify-between gap-6 py-4 px-4"}>
        <div
          className={
            " w-full rounded-md border-[1px] bg-brand-light flex items-center justify-center"
          }
        >
          <p className={"text-base text-center text-brand"}>
            {t("one_to_one.your_credits")}:&nbsp;
            <strong className={cn({ "!text-secondary": stateCredits === 0 })}>
              {stateCredits}
            </strong>
          </p>
        </div>
        <Button
          onClick={() => navigate(routes.one_to_one_recharge)}
          className={"w-full"}
          color={"primary"}
        >
          {t("btns.recharge")}
        </Button>
      </div>}


      <div
        className={
          "flex bg-white flex-col w-full flex-grow md:flex-grow md:min-h-0  pt-2 justify-center gap-3"
        }
      >
        <div className={"flex flex-col gap-1 w-full px-4"}>
          {heading ? (
            <>
              <h2
                className={
                  "text-sm  font-semibold text-secondary '"
                }
              >
                {heading}
              </h2>
              {subheading && (
                <p className={"text-xs ] text-secondary"}>
                  {subheading}
                </p>
              )}
            </>
          ) : (
            <>
              <h2 className={"text-sm font-semibold text-secondary"}>
                {t("one_to_one.mobile_title_section")}
              </h2>
              <p className={"text-xs text-secondary"}>
                {t("one_to_one.mobile_subtitle_section")}
              </p>
            </>
          )}
        </div>
        <div
          className={cn(
            "flex bg-white h-auto flex-col flex-1 justify-between items-center flex-grow px-4 gap-3 pb-2",
            className,
          )}
        >
          <>{children}</>
        </div>
      </div>
    </div>
  );
};

export default MobileLayout;
